import { useNavigate } from 'react-router-dom';
import './home.css';

export default function Home({ darkMode }) {
    const navigate = useNavigate();

    return (
        <div className="home">
            <h2>Welcome</h2>
            <button
                className={`play-button ${darkMode ? "dark-background" : "light-background"}`}
                onClick={() => navigate("/game")}
            >
                Play a game
            </button>
            <h2>Rules</h2>
            <ul className="rules-list">
                <li>Game is played by three players</li>
                <li>Each player has 5 pieces to place and move</li>
                <li>Phase 1 (Placement): Players take turns placing pieces on empty cells</li>
                <li>Phase 2 (Movement): Players roll a die (1-6) and move one piece that exact number of steps in any direction (horizontal, vertical, or diagonal)</li>
                <li>Pieces cannot jump over other pieces</li>
                <li>If no valid move is available, the player skips their turn</li>
                <li>First player to connect all 5 pieces in a straight line wins</li>
            </ul>
        </div>
    )
}
